import { render, staticRenderFns } from "./ListGrid.vue?vue&type=template&id=971a3420&"
import script from "./ListGrid.vue?vue&type=script&lang=js&"
export * from "./ListGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports